import {
  faClock,
  faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@design-system/components/typography/typography';
import { HeldEdit } from '../model/post.types';

type Props = {
  kind: Exclude<HeldEdit, 'none'>;
};

const NOTICES = {
  processing: {
    icon: faClock,
    text: 'Members still see the previous version of this post. Your changes will go live when the pending attachment finishes processing.',
  },
  failed: {
    icon: faTriangleExclamation,
    text: 'An attachment in this edit could not be processed, so members still see the previous version. Edit the post and remove the failed attachment to publish your changes.',
  },
} satisfies Record<Props['kind'], unknown>;

export const HeldEditNotice = ({ kind }: Props) => (
  <div
    role="status"
    className="flex items-start gap-2 rounded-[10px] bg-gray-100 p-3 text-gray-500"
  >
    <FontAwesomeIcon icon={NOTICES[kind].icon} className="mt-0.5" />
    <Typography as="span" variant="body" size="small" className="text-gray-500">
      {NOTICES[kind].text}
    </Typography>
  </div>
);
